import React from 'react';
import overview from '../assets/overview-skewed.png';
import kylo from '../assets/fuse-kylo-skewed.png';
import solana from '../assets/fuse-solana-skewed.png';

function Products() {
    const products = [
        {
            name: "Fuse Chrome",
            description: "Autofill reinvented. A state-of-the-art chrome extension that will help you check out anywhere in seconds.",
            features: [
                ">1M sites supported",
                "Custom scripts",
                "<5s checkout time"
            ],
            image: overview,
            available: false
        },
        {
            name: "Fuse Kylo",
            description: "Your dedicated e-commerce automation toolkit. A desktop application enabling you to automate anything and check out at lightning speeds",
            features: [
                "100+ sites supported",
                "Autonomous operation",
                "<1s checkout time"
            ],
            image: kylo,
            available: false
        },
        {
            name: "Fuse Solana",
            description: "Shop your favorite digital artwork. The first desktop application that enables you to buy NFTs when they come out in your sleep.",
            features: [
                "Solana, Ethereum, Aptos supported",
                "Autonomous operation",
                "<1s checkout time"
            ],
            image: solana,
            available: false
        }
    ];

    return (
        <div id="products" className="py-16 md:py-24">
            <div className="text-center mb-12 md:mb-16">
                <h2 className="text-3xl md:text-5xl font-bold text-white mb-4">
                    Our Products
                </h2>
                <p className="text-lg md:text-xl text-gray-400 max-w-2xl mx-auto">
                    Cutting-edge automation software engineered for performance and reliability
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
                {products.map((product, index) => (
                    <div 
                        key={index}
                        className="bg-gradient-to-br from-gray-800/50 to-gray-900/50 border border-gray-700 rounded-2xl overflow-hidden hover:border-fuse-orange transition-all hover:scale-105 flex flex-col"
                    >
                        {/* Product Image */}
                        <div className="bg-gray-900/50 h-48 md:h-56 flex items-center justify-center p-4">
                            <img 
                                src={product.image} 
                                alt={product.name}
                                className="w-full h-full object-contain"
                            />
                        </div>

                        {/* Product Content */}
                        <div className="p-6 md:p-8 flex flex-col flex-grow">
                            <h3 className="text-2xl md:text-3xl font-bold text-white mb-3">
                                {product.name}
                            </h3>
                            
                            <p className="text-gray-400 mb-6 min-h-[60px]">
                                {product.description}
                            </p>

                            {/* Features List */}
                            <div className="mb-6 space-y-3 flex-grow">
                                {product.features.map((feature, featureIndex) => (
                                    <div key={featureIndex} className="flex items-start gap-3">
                                        <span className="text-fuse-orange text-lg mt-0.5">✓</span>
                                        <span className="text-gray-300 text-sm md:text-base">{feature}</span>
                                    </div>
                                ))}
                            </div>

                            <a 
                                href={product.available ? "//dash.fuserobotics.io" : "#"}
                                className={`block text-center py-3 px-6 rounded-full font-semibold transition-colors mt-auto ${
                                    product.available 
                                        ? "bg-fuse-orange text-white hover:opacity-90" 
                                        : "bg-gray-700 text-gray-400 cursor-not-allowed"
                                }`}
                            >
                                {product.available ? "Learn More" : "Sold Out"}
                            </a>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Products;

